import React from 'react';
import { getPlayerIdByName } from "../../../../Controllers/PlayerRankingApi";
import { actions } from "../../../../Redux/store";
import { useMixpanel } from '../../../../Context/MixpanelContext/MixpanelProvider';

interface ClickableBoldProps {
  children: React.ReactNode;
}

const ClickableBold: React.FC<ClickableBoldProps> = ({
  children,
}) => {
  const Mixpanel = useMixpanel()
  const handleClick = async () => {
    // Extract the text content from the children
    const textContent = React.Children.toArray(children)
      .map((child) =>
        typeof child === "string"
          ? child
          : (child as React.ReactElement)?.props?.children || "",
      )
      .join("");

    try {
      console.log("Fetching player ID for:", textContent);
      Mixpanel.trackEvent("chatbot_player_name_clicked", {
        name: "User clicked on the player name in the chatbot",
        playerName: textContent,
      });
      const response = await getPlayerIdByName(textContent);

      const playerId = response?.data?.[0]?.roto_player_id;
      if (playerId) {
        actions.modal.openPlayerProfileModal({ playerId: playerId });
        console.log("Player ID:", playerId);
      } else {
        console.warn("Player ID not found for:", textContent);
      }
    } catch (error) {
      console.error("Error fetching player data:", error);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    // Execute click action when Enter or Space is pressed
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <span
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      style={{ 
        cursor: "pointer", 
        fontWeight: "bold", 
        textDecoration: "underline", 
        textDecorationColor: "white" 
      }}
      className="clickable-bold"
    >
      {children}
    </span>
  );
};

export default ClickableBold;
